module.exports = __webpack_public_path__ + "img/open.ea62db76.png";